import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material';

//fonts
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/700.css';

//components
import Layout from './components/layout';
import Body from './components/layout/Body';
import PrivateRoute from './components/layout/PrivateRoute';
import ResetPassword from './components/login/ResetPassword';
import CustomThemeProvider from './components/common/ThemeContext';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#ff9800',
    },
    secondary: {
      main: '#000000',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20,
        },
      },
    },
  },
  typography: {
    fontFamily: 'Open Sans, Roboto',
    h2: {
      fontSize: '28px',
      fontFamily: 'Open Sans',
      fontWeight: 'semibold',
      fontStyle: 'italic',
    },
    h3: {
      fontSize: '14px',
      fontFamily: 'Open Sans',
      fontWeight: 'semibold',
    },
    h4: {
      fontSize: '18px',
      fontFamily: 'Open Sans',
      fontStyle: 'italic',
    },
    h5: {
      fontSize: '16px',
      fontFamily: 'Open Sans',
      fontWeight: 'semibold',
    },
    body1: {
      fontSize: '14px',
      fontWeight: 'regular',
    },
  },
});

const router = createBrowserRouter([
  {
    path: `/reset-password`,
    element: <ResetPassword />,
  },
  {
    path: `/`,
    element: (
      <PrivateRoute>
        <Layout />
      </PrivateRoute>
    ),
    children: [
      {
        path: '',
        element: <Body />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <ReactKeycloakProvider authClient={keycloak}>
  <Provider store={store}>
    <CustomThemeProvider>
      <RouterProvider router={router} />
    </CustomThemeProvider>
  </Provider>,
  //</ReactKeycloakProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
